"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Fandom = function Fandom(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.604.012a.603.603 0 00-.416.175l-4.493 4.485a.9.9 0 01-1.263.002L6.939.236a.603.603 0 00-.841-.002L.31 5.871c-.2.194-.311.457-.311.733v5.34c0 .271.11.533.305.726l11.277 11.144a.603.603 0 00.846 0L23.695 12.67c.194-.193.305-.454.305-.727V6.605c0-.27-.107-.528-.299-.72L18.04.189a.603.603 0 00-.435-.177zM6.615 2.5a.292.292 0 01.2.084l8.138 8.047a2.19 2.19 0 010 3.119l-2.43 2.4a.293.293 0 01-.408 0l-8.14-8.046a2.172 2.172 0 01-.65-1.561c0-.59.23-1.143.648-1.557l2.431-2.402a.292.292 0 01.211-.084zm11.15.707a2.241 2.241 0 01.278.022c.5.067.955.327 1.312.68l2.57 2.542a.284.284 0 010 .404l-3.91 3.868a.29.29 0 01-.41 0l-4-3.955a.285.285 0 010-.407l2.54-2.51a2.241 2.241 0 011.62-.644zm4.087 6.123a.29.29 0 01.341.283v1.705h-.002c0 .2-.08.39-.222.532l-9.28 9.306a.686.686 0 01-.511.225.743.743 0 01-.533-.227l-.655-.613a.284.284 0 01-.008-.41L21.697 9.412a.287.287 0 01.155-.082zm-19.424.106c.1.016.197.062.281.144l7.5 7.322c.13.13.35.396.35.717 0 .205-.047.495-.27.717l-.002-.002-.531.477a.445.445 0 01-.604-.014l-7.064-6.899a.917.917 0 01-.277-.658V9.951c0-.348.317-.566.617-.515Z"
  }));
};

Fandom.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Fandom.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Fandom;
exports["default"] = _default;